import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FitterRouterService } from './services/router.service';

@NgModule({
  imports: [CommonModule],
  providers: [FitterRouterService],
})
export class FeatureFitterPathRouterSystemModule {}
